import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, ToastController } from 'ionic-angular';
import { Validators, FormBuilder } from '@angular/forms';
import { DiaryData } from '../../providers/diary';
import { Translate } from '../../providers/translate';
import { SpeakerData } from '../../providers/speaker';
import { EventData } from '../../providers/event';

@Component({
  selector: 'page-event-comment',
  templateUrl: 'event-comment.html'
})
export class EventCommentPage {

  obs: any;
  comments: any;
  event: any;
  client: any;
  token2: any;
  title: any;
  type: any;
  dataComment: any;
  commentForm: any;
  textTranslate: any;

  constructor(public navCtrl: NavController, public params: NavParams, public formBuilder: FormBuilder, public loading: LoadingController, public diaryProvider: DiaryData, public speakerProvider: SpeakerData, public toastCtrl: ToastController, public eventProvider: EventData, translate: Translate) {

    translate.translateGroup(['Guardando', 'Comentario enviado correctamente'])
    .then(result => {
      this.textTranslate = result;
    });

    this.type = params.get('type');
    this.title = params.get('title');
    this.event = params.get('event');
    this.token2 = params.get('token2');
    this.client = params.get('client');

    if (this.type == 'speaker') {
      this.obs = speakerProvider.getComments(this.client, this.event.id, this.event.id).subscribe((dataSnapshot: any) => {
        this.comments = dataSnapshot;
      });
    } else if (this.type == 'resource') {
      this.obs = speakerProvider.getResourceComments(this.client, this.event.id, this.token2).subscribe((dataSnapshot: any) => {
        this.comments = dataSnapshot;
      });
    } else if (this.type == 'activity') {
      this.obs = speakerProvider.getCommentsActivity(this.client, this.token2).subscribe((dataSnapshot: any) => {
        this.comments = dataSnapshot;
      });
    } else if (this.type == 'diary') {
      this.obs = diaryProvider.getComments(this.client, this.token2).subscribe((dataSnapshot: any) => {
        this.comments = dataSnapshot;
      });
    }

		this.dataComment = {
			comment: ''
		};

    this.commentForm = this.formBuilder.group({
      comment: ['', Validators.required]
    });
  }

  create() {
		if (this.commentForm.valid) {
      let loader = this.loading.create({
        content: this.textTranslate['Guardando'],
        duration: 3000
      });

      loader.present();
      let op;
      let transactionOp: any = false;

      if (this.type == 'speaker') {
        transactionOp = 'numCommentsSpeakers';
        op = this.speakerProvider.pushComment(this.client, this.event.id, this.event.id, this.dataComment.comment);
      } else if (this.type == 'resource') {
        transactionOp = 'numCommentsResources';
        op = this.speakerProvider.pushResourceComment(this.client, this.event.id, this.token2, this.dataComment.comment);
      } else if (this.type == 'activity') {
        transactionOp = 'numCommentsResources';
        op = this.speakerProvider.pushResourceActivityComment(this.client, this.event.id, this.token2, this.dataComment.comment);
      } else if (this.type == 'diary') {
        transactionOp = 'numCommentsDiary';
        op = this.diaryProvider.pushComment(this.client, this.event.id, this.token2, this.dataComment.comment);
      }

      op.then((data) => {
        this.commentForm.reset();

        // Increase counter dashboard
        this.eventProvider.setTransactionDashboard(this.client, this.event, transactionOp);

        let toast = this.toastCtrl.create({
          message: this.textTranslate['Comentario enviado correctamente'],
          duration: 5000
        });
        loader.dismiss();
        toast.present();
      })
      .catch(error => {
        let toast = this.toastCtrl.create({
          message: error,
          duration: 5000
        });
        loader.dismiss();
        toast.present();
      });
		}
  }

  // Unsubsucribe observables on exit page
  ionViewDidLeave() {
    console.log('Se elimina el observable de comentarios');
    this.obs.unsubscribe();
  }
}
// TODO: orderBy list timestamp reverse
// end file



// WEBPACK FOOTER //
// ./src/pages/event-comment/event-comment.ts